import React from 'react';

const AssetAdministration = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Asset Administration and Management
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures provides comprehensive asset administration and management services, ensuring optimal performance, regulatory compliance, and value preservation for diverse portfolios across multiple asset classes.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Our Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Portfolio Administration</h3>
                <p className="text-gray-700">
                  Professional administration services for investment portfolios including recordkeeping, reporting, compliance oversight, and performance monitoring.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Asset Management</h3>
                <p className="text-gray-700">
                  Strategic asset management across multiple asset classes including equities, fixed income, real estate, and alternative investments for optimal returns.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Compliance & Regulatory</h3>
                <p className="text-gray-700">
                  Ensuring full compliance with regulatory requirements, implementing controls, and maintaining adherence to industry standards and best practices.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Performance Reporting</h3>
                <p className="text-gray-700">
                  Detailed performance reporting and analytics providing transparency, insights, and actionable intelligence for informed decision-making.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-primary mb-4">Key Benefits</h2>
            <ul className="space-y-3 text-gray-700 mb-8">
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Efficiency:</strong> Streamlined administration reducing operational complexity and costs</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Transparency:</strong> Clear visibility into asset performance and portfolio composition</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Risk Management:</strong> Comprehensive risk assessment and mitigation strategies</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Value Preservation:</strong> Protecting and enhancing asset value through professional management</span>
              </li>
            </ul>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Optimize Your Asset Management</h3>
              <p className="mb-6">
                Partner with Vajreya Ventures for professional asset administration and management services.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetAdministration;